import React, { useEffect, useRef, useState } from "react";

const ChooseImage = ({ onClose, onCrop, type, defaultImage }) => {
  const inputRef = useRef(null);
  const croppedImageRef = useRef(null);
  const croppieInstance = useRef(null);
  const [imageSelected, setImageSelected] = useState(false);

  useEffect(() => {
    if (!window.Croppie) {
      console.error(
        "Croppie is not loaded. Ensure the script is included in index.html"
      );
      return;
    }

    if (croppedImageRef.current && !croppieInstance.current) {
      let viewportWidth = 370;
      let viewportHeight = 210;

      if (window.screen.width >= 768) {
        viewportWidth = 555;
        viewportHeight = 315;
      }

      const isProfileImg = type === "ProfileImg";

      croppieInstance.current = new window.Croppie(croppedImageRef.current, {
        viewport: {
          width: isProfileImg ? viewportHeight : viewportWidth,
          height: viewportHeight,
          type: isProfileImg ? "circle" : "square",
        },
        boundary: {
          width: viewportWidth + 30,
          height: viewportHeight + 30,
        },
      });

      // ✅ preload default image if provided
      if (defaultImage) {
        croppieInstance.current
          .bind({ url: defaultImage })
          .then(() => setImageSelected(true))
          .catch((error) =>
            console.error("Error binding default image:", error)
          );
      }
    }

    return () => {
      if (croppieInstance.current) {
        croppieInstance.current.destroy();
        croppieInstance.current = null;
      }
    };
  }, [defaultImage, type]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (croppieInstance.current) {
          croppieInstance.current
            .bind({ url: e.target.result })
            .then(() => setImageSelected(true))
            .catch((error) => console.error("Error binding image:", error));
        }
      };
      reader.readAsDataURL(file);
    }
  };

const handleCrop = () => {
  if (imageSelected && croppieInstance.current) {

    const viewport = croppieInstance.current.options.viewport;

    croppieInstance.current.result({
      type: "base64",
      format: "jpeg",
      quality: 1, // 🔥 max quality
      size: {
        width: viewport.width * 2,   // 🔥 2x
        height: viewport.height * 2
      }
    }).then((result) => {
      onCrop(result);
      onClose();
    });

  } else {
    const label = document.getElementById("customFileLabel");
    label.classList.add("shake");
    label.addEventListener("animationend", () => {
      label.classList.remove("shake");
    });
  }
};

  return (
    <div className="modal">
      <div className="modal-content">
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleFileChange}
        />
        <label
          htmlFor="inputImage"
          id="customFileLabel"
          onClick={() => inputRef.current.click()}
        >
          Select an Image
        </label>
        <span
          style={{
            fontSize: "35px",
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
          }}
          onClick={onClose}
        >
          &times;
        </span>
        <div ref={croppedImageRef}></div>
        <button className="cropButton" onClick={handleCrop}>
          Crop Image
        </button>
      </div>
    </div>
  );
};

export default ChooseImage;
